// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  BuildMinified,
  BuildMinifiedFromJSON,
  BuildMinifiedToJSON,
  ExecutionContext,
  ExecutionContextFromJSON,
  ExecutionContextToJSON,
  Project,
  ProjectFromJSON,
  ProjectToJSON,
  StepWiseResult,
  StepWiseResultFromJSON,
  StepWiseResultToJSON,
  TestCaseRevision,
  TestCaseRevisionFromJSON,
  TestCaseRevisionToJSON,
  TestDatasetWiseResult,
  TestDatasetWiseResultFromJSON,
  TestDatasetWiseResultToJSON,
  TestPlanTestCase,
  TestPlanTestCaseFromJSON,
  TestPlanTestCaseToJSON,
  Upload,
  UploadFromJSON,
  UploadToJSON,
  User,
  UserFromJSON,
  UserToJSON,
} from "./";

/**
 *
 * @export
 * @interface ExecutedTestCase
 */
export interface ExecutedTestCase {
  /**
   *
   * @type {number}
   * @memberof ExecutedTestCase
   */
  id: number;
  /**
   *
   * @type {TestPlanTestCase}
   * @memberof ExecutedTestCase
   */
  testPlanTestCase: TestPlanTestCase;
  /**
   *
   * @type {TestCaseRevision}
   * @memberof ExecutedTestCase
   */
  testCaseRevision?: TestCaseRevision;
  /**
   *
   * @type {Project}
   * @memberof ExecutedTestCase
   */
  project?: Project;
  /**
   *
   * @type {string}
   * @memberof ExecutedTestCase
   */
  comment?: string;
  /**
   *
   * @type {Array<Upload>}
   * @memberof ExecutedTestCase
   */
  attachments?: Array<Upload>;
  /**
   * Test Plan's Configuration ID
   * @type {number}
   * @memberof ExecutedTestCase
   */
  testPlanConfig?: number;
  /**
   * Test Plan's ID
   * @type {number}
   * @memberof ExecutedTestCase
   */
  testPlan?: number;
  /**
   *
   * @type {BuildMinified}
   * @memberof ExecutedTestCase
   */
  build?: BuildMinified;
  /**
   * Test Plan's Regression ID
   * @type {number}
   * @memberof ExecutedTestCase
   */
  regression?: number;
  /**
   * Executed test case assigned to
   * @type {number}
   * @memberof ExecutedTestCase
   */
  assignedTo?: number;
  /**
   * System name of the status, used for internal references
   * @type {string}
   * @memberof ExecutedTestCase
   */
  status: string;
  /**
   * Number of seconds taken for this test
   * @type {number}
   * @memberof ExecutedTestCase
   */
  timeTaken?: number;
  /**
   *
   * @type {User}
   * @memberof ExecutedTestCase
   */
  executedBy?: User;
  /**
   *
   * @type {Array<StepWiseResult>}
   * @memberof ExecutedTestCase
   */
  stepWiseResult?: Array<StepWiseResult>;
  /**
   *
   * @type {string}
   * @memberof ExecutedTestCase
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof ExecutedTestCase
   */
  updatedAt: string;
  /**
   *
   * @type {number}
   * @memberof ExecutedTestCase
   */
  validationStatus?: number;
  /**
   * JSON string of validation data
   * @type {string}
   * @memberof ExecutedTestCase
   */
  validationData?: string;
  /**
   * JSON string of test dataset
   * @type {string}
   * @memberof ExecutedTestCase
   */
  testdataset?: string;
  /**
   *
   * @type {Array<TestDatasetWiseResult>}
   * @memberof ExecutedTestCase
   */
  testdatasetWiseResult?: Array<TestDatasetWiseResult>;
  /**
   *
   * @type {string}
   * @memberof ExecutedTestCase
   */
  runOn?: string;
  /**
   * TCV-6814. How this result was produced: manual (a person in the app), ci (a pipeline), api (a token-authenticated caller that did not say more), agent (QA Copilot or another agent) or import. Null on results recorded before this was tracked — absent rather than guessed.
   * @type {string}
   * @memberof ExecutedTestCase
   */
  executionSource?: ExecutedTestCaseExecutionSourceEnum;
  /**
   *
   * @type {ExecutionContext}
   * @memberof ExecutedTestCase
   */
  executionContext?: ExecutionContext;
}

export function ExecutedTestCaseFromJSON(json: any): ExecutedTestCase {
  return {
    id: json["id"],
    testPlanTestCase: TestPlanTestCaseFromJSON(json["test_plan_test_case"]),
    testCaseRevision: !exists(json, "test_case_revision")
      ? undefined
      : TestCaseRevisionFromJSON(json["test_case_revision"]),
    project: !exists(json, "project")
      ? undefined
      : ProjectFromJSON(json["project"]),
    comment: !exists(json, "comment") ? undefined : json["comment"],
    attachments: !exists(json, "attachments")
      ? undefined
      : (json["attachments"] as Array<any>).map(UploadFromJSON),
    testPlanConfig: !exists(json, "test_plan_config")
      ? undefined
      : json["test_plan_config"],
    testPlan: !exists(json, "test_plan") ? undefined : json["test_plan"],
    build: !exists(json, "build")
      ? undefined
      : BuildMinifiedFromJSON(json["build"]),
    regression: !exists(json, "regression") ? undefined : json["regression"],
    assignedTo: !exists(json, "assigned_to") ? undefined : json["assigned_to"],
    status: json["status"],
    timeTaken: !exists(json, "time_taken") ? undefined : json["time_taken"],
    executedBy: !exists(json, "executed_by")
      ? undefined
      : UserFromJSON(json["executed_by"]),
    stepWiseResult: !exists(json, "step_wise_result")
      ? undefined
      : (json["step_wise_result"] as Array<any>).map(StepWiseResultFromJSON),
    createdAt: json["created_at"],
    updatedAt: json["updated_at"],
    validationStatus: !exists(json, "validation_status")
      ? undefined
      : json["validation_status"],
    validationData: !exists(json, "validation_data")
      ? undefined
      : json["validation_data"],
    testdataset: !exists(json, "testdataset") ? undefined : json["testdataset"],
    testdatasetWiseResult: !exists(json, "testdataset_wise_result")
      ? undefined
      : (json["testdataset_wise_result"] as Array<any>).map(
          TestDatasetWiseResultFromJSON
        ),
    runOn: !exists(json, "run_on") ? undefined : json["run_on"],
    executionSource: !exists(json, "execution_source")
      ? undefined
      : json["execution_source"],
    executionContext: !exists(json, "execution_context")
      ? undefined
      : ExecutionContextFromJSON(json["execution_context"]),
  };
}

export function ExecutedTestCaseToJSON(value?: ExecutedTestCase): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    test_plan_test_case: TestPlanTestCaseToJSON(value.testPlanTestCase),
    test_case_revision: TestCaseRevisionToJSON(value.testCaseRevision),
    project: ProjectToJSON(value.project),
    comment: value.comment,
    attachments:
      value.attachments === undefined
        ? undefined
        : (value.attachments as Array<any>).map(UploadToJSON),
    test_plan_config: value.testPlanConfig,
    test_plan: value.testPlan,
    build: BuildMinifiedToJSON(value.build),
    regression: value.regression,
    assigned_to: value.assignedTo,
    status: value.status,
    time_taken: value.timeTaken,
    executed_by: UserToJSON(value.executedBy),
    step_wise_result:
      value.stepWiseResult === undefined
        ? undefined
        : (value.stepWiseResult as Array<any>).map(StepWiseResultToJSON),
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    validation_status: value.validationStatus,
    validation_data: value.validationData,
    testdataset: value.testdataset,
    testdataset_wise_result:
      value.testdatasetWiseResult === undefined
        ? undefined
        : (value.testdatasetWiseResult as Array<any>).map(
            TestDatasetWiseResultToJSON
          ),
    run_on: value.runOn,
    execution_source: value.executionSource,
    execution_context: ExecutionContextToJSON(value.executionContext),
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ExecutedTestCaseExecutionSourceEnum {
  Manual = "manual",
  Ci = "ci",
  Api = "api",
  Agent = "agent",
  Import = "import",
}
